import React from 'react';
import { DetailObject } from '../types';

export default React.createContext<{ object: DetailObject | undefined, setObject: (object: DetailObject) => void }>({ object: undefined, setObject: (object) => { } });

